import React, { useState } from "react";
import Form_Header from "../../../common/form-header/Form_Header";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";
import { Form } from "react-bootstrap";
import "./Create_Account_Step6.css";
import Full_Screen_Modal from "../../../full-screen-modal/Full_Screen_Modal";
import { useNavigate } from "react-router-dom";
import { Registration_Lottie } from "../../../lotties/registration-lottie/Registration_Lottie";
const Create_Account_Step6 = ({ setStep }) => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [selected, setSelected] = useState("Weight Gain");

  const goals = ["Beginner", "Intermediate", "Advance"];
  return (
    <section className="step1_wrapper step3_wrapper step5_wrapper">
      <Form_Header step={6} totalSteps={6} />
      <div className="weight_selection_div business_constitution_div">
        <h2 className="select_title">Physical Activity Level</h2>
        <div className="goal_wrapper">
          <Form>
            {goals.map((goal) => (
              <div
                key={goal}
                className={`goal_item ${selected === goal ? "active" : ""}`}
                onClick={() => setSelected(goal)}
              >
                <span className="goal_text">{goal}</span>

                <Form.Check
                  type="radio"
                  name="goal"
                  checked={selected === goal}
                  readOnly
                />
              </div>
            ))}
          </Form>

          <div className="terms_wrapper">
            <Form.Check
              type="checkbox"
              id="terms"
              className="terms_check"
              label={
                <span className="terms_span">
                  By continuing, I agree GYMIFY’s {""}
                  <a className="terms_link">Terms of Use & Privacy Policy </a>
                </span>
              }
            />
          </div>
        </div>
        <div className="form_btn_holder">
          <White_Btn btnText="Back" onClick={() => setStep(5)} />
          {/* <Common_Btn
            btnText="Register"
            onClick={() => {
              setShowModal(true);

              setTimeout(() => {
                setShowModal(false);
                navigate("/home");
              }, 2500);
            }}
          /> */}
          <Common_Btn btnText="Register" onClick={() => setStep(7)} />
        </div>
      </div>

      <Full_Screen_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        lottie={<Registration_Lottie />}
      />
    </section>
  );
};

export default Create_Account_Step6;
